import styled from 'styled-components';
import sharedStyles from './styles';
import breakpoints from './breakpoints';

const GridCardContainer = styled.div`
  display: grid;
  gap: ${sharedStyles.spacing['spacing-lg']};
  margin-top: ${sharedStyles.spacing['spacing-lg']};

  @media (min-width: ${breakpoints.sm}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: ${breakpoints.lg}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: ${sharedStyles.spacing['spacing-1xl']};
  }

  @media (min-width: ${breakpoints.xl}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

export default GridCardContainer;
